module.exports = __webpack_public_path__ + "img/banner-4-min.642702f1.png";